module.exports = __webpack_public_path__ + "img/move-forward.b3431527.gif";